import { render } from "./RecordList.vue?vue&type=template&id=52f07631&scoped=true&ts=true"
import script from "./RecordList.vue?vue&type=script&lang=ts"
export * from "./RecordList.vue?vue&type=script&lang=ts"

import "./RecordList.vue?vue&type=style&index=0&id=52f07631&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f07631"]])

export default __exports__